import { render } from "./AppLayout.vue?vue&type=template&id=9a07f26c"
import script from "./AppLayout.vue?vue&type=script&lang=js"
export * from "./AppLayout.vue?vue&type=script&lang=js"
script.render = render

export default script